export default {
  List: {
    Title: "Kiểm đếm",
    AddButton: "Lập biên bản kiểm đếm",
    Search: "Tìm kiếm theo số biên bản, ngày kiểm đếm,...",
  },
  Detail: {
    Add: "Lập biên bản kiểm đếm",
    Edit: "Sửa biên bản kiểm đếm",
    OrganizationUnit: "Đơn vị",
    Location: "Vị trí địa lý",
    TallyDate: "Đến ngày",
    AssetType: "Loại tài sản",
    TallyNo: "Số biên bản",
    Description: "Tên biên bản",
    Target: "Mục đích",
    Status: "Trạng thái",
    IsAuditByLocation: "Kiểm đếm theo vị trí địa lý",
  },
  ListTab: {
    GeneralInfo: "Thông tin chung",
    TallyAssetList: "Danh sách tài sản kiểm đếm",
    AssetOther: "Tài sản ngoài danh sách",
  },
  LayoutGrid: {
    AssetType: "Loại tài sản",
    LedgerQuantity: "Số lượng ghi sổ",
    RealQuantity: "Số lượng thực tế",
    Difference: "Chênh lệch",
    AssetLocationLedger: "Vị trí tài sản (Ghi sổ)",
    AssetLocationReal: "Vị trí tài sản (Thực tế)",
    AssetStatus: "Hiện trạng tài sản",
    Solution: "Biện pháp xử lý",
  },
  General: {
    Description: "Nội dung",
    Type: "Loại kiểm kê",
    OrganizationUnit: "Đơn vị",
    AssetLocation: "Vị trí tài sản",
    StartDate: "Ngày bắt đầu",
    EndDate: "Ngày kết thúc",
    AssetGroup: "Nhóm tài sản",
    TallyByLocation: "Kiểm đếm theo vị trí tài sản",
  },
};
